import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.26 5h21.48a2 2 0 0 1 1.48 3.345L20 17.387v7.078a2 2 0 0 1-.89 1.664l-4 2.667A2 2 0 0 1 12 27.13v-9.744L3.78 8.345A2 2 0 0 1 5.26 5m21.478 2H5.261l8.219 9.041a2 2 0 0 1 .511 1.16l.009.186v9.744l4-2.666v-7.078a2 2 0 0 1 .52-1.346z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFunnel = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFunnel);
export default Memo;
